import Transition from '@ember/routing/-private/transition';
import ObjectModel from 'cio/models/object';
import ObjectTypeModel from 'cio/models/object-type';
import LogsRoute from 'cio/pods/logs/route';
import ObjectActivityController from './controller';

export default class ObjectActivityRoute extends LogsRoute {
  crumb() {
    let model = this.modelFor('object') as ObjectTypeModel;
    return {
      name: 'Activity Logs',
      path: 'object.activity',
      model: model?.id ?? '',
    };
  }

  model() {
    return this.modelFor('object');
  }

  setupController(controller: ObjectActivityController, model: ObjectModel, transition: Transition) {
    super.setupController(controller, model, transition);
    controller.objectType = this.modelFor('objects.type') as ObjectTypeModel;
  }
}
